<!-- Document click listener for closing popups -->
<div (document:click)="onDocumentClick($event)" style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; pointer-events: none; z-index: -1;"></div>

<!-- Floating Clear All Filters Button -->
<button *ngIf="hasActiveFilters()" 
        class="floating-clear-btn" 
        mat-fab 
        color="warn" 
        (click)="clearAllFilters()">
  <mat-icon>filter_alt_off</mat-icon>
  <span class="button-text">Clear All</span>
</button>

<!-- Call list global search -->
<div class="call-list-search-container mb-3">
  <div class="call-list-search-input-wrap">
    <input type="text" 
           class="call-list-search-input" 
           placeholder="Search (e.g. name, phone, status)..." 
           [(ngModel)]="searchInput"
           (keyup.enter)="onSearch()" />
    <div class="call-list-search-icon-wrap"
         role="button"
         tabindex="0"
         (click)="onSearch()"
         (keyup.enter)="onSearch()">
      <span class="material-icons call-list-search-icon">search</span>
    </div>
  </div>
  <button type="button" class="call-list-search-clear" *ngIf="searchInput || searchTerm" (click)="onClearSearch()">
    clear
  </button>
</div>

<div class="mat-elevation-z8 mt-4 call-list-table" style="position: relative;">
  <div *ngIf="isLoading" style="position:absolute;inset:0;display:flex;align-items:center;justify-content:center;background:rgba(255,255,255,0.6);z-index:2;">
    <mat-progress-spinner mode="indeterminate" color="primary" diameter="32" strokeWidth="4"></mat-progress-spinner>
  </div>
  
  <table mat-table [dataSource]="dataSource" matSort class="mat-elevation-z8">
    

    <!-- Patient ID -->
    <ng-container matColumnDef="patient_id">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-with-filter">
          <span>Patient ID</span>
          <button mat-icon-button class="filter-icon" 
                  [class.active]="activeFilterColumn === 'patient_id'"
                  (click)="openColumnFilter('patient_id', $event)">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>
        <!-- Filter popup -->
        <div class="filter-popup" *ngIf="activeFilterColumn === 'patient_id'" 
             [style.top]="popupPosition.top" 
             [style.left]="popupPosition.left">
          <!-- Active filter tags -->
          <div class="filter-tags" *ngIf="getFilterValues('patient_id').length > 0">
            <span class="filter-tag" *ngFor="let value of getFilterValues('patient_id')">
              {{ value }}
              <button class="remove-tag" (click)="removeFilterValue('patient_id', value, $event)">×</button>
            </span>
          </div>
          <!-- Input for new filter -->
          <div class="filter-input-group">
            <input matInput 
                   placeholder="Filter patient ID..." 
                   [value]="getTempFilterValue('patient_id')"
                   (input)="onInputChange('patient_id', $event)"
                   (keydown)="onKeyDown('patient_id', $event)"
                   (keyup.enter)="addFilterValue('patient_id', getTempFilterValue('patient_id'))"
                   (keydown.escape)="setTempFilterValue('patient_id', ''); activeFilterColumn = null"
                   (click)="onInputClick($event)"
                   (focus)="onInputFocus($event)">
            <button mat-button class="add-filter-btn" 
                    (click)="addFilterValue('patient_id', getTempFilterValue('patient_id'))"
                    [disabled]="!getTempFilterValue('patient_id') || getTempFilterValue('patient_id').trim() === ''">
              Add
            </button>
          </div>
          <button mat-button class="clear-btn" (click)="clearColumnFilter('patient_id', $event)">Clear All</button>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.patient_id }}</td>
    </ng-container>

    <!-- Last Update -->
    <ng-container matColumnDef="last_update">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-with-filter">
          <span>Last Update</span>
          <button mat-icon-button class="filter-icon"
                  [class.active]="activeFilterColumn === 'last_update'"
                  (click)="openColumnFilter('last_update', $event)">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>
        <div class="filter-popup date-filter-popup" *ngIf="activeFilterColumn === 'last_update'"
             [style.top]="popupPosition.top"
             [style.left]="popupPosition.left">
          <div class="filter-tags" *ngIf="columnFilters['last_update']">
            <span class="filter-tag">
              {{ getDateRangeDisplay('last_update') }}
              <button class="remove-tag" (click)="clearDateRangeFilter('last_update', $event)">×</button>
            </span>
          </div>
          <div class="date-range-filter">
            <mat-form-field appearance="outline" class="date-range-field">
              <mat-label>Enter a date range</mat-label>
              <mat-date-range-input [rangePicker]="lastUpdatePicker" (click)="onInputClick($event)">
                <input matStartDate placeholder="Start date" [(ngModel)]="dateRangeFilters['last_update'].start" />
                <input matEndDate placeholder="End date" [(ngModel)]="dateRangeFilters['last_update'].end" />
              </mat-date-range-input>
              <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
              <mat-datepicker-toggle matIconSuffix [for]="lastUpdatePicker"></mat-datepicker-toggle>
              <mat-date-range-picker #lastUpdatePicker (closed)="onDateRangePickerClosed('last_update')">
                <mat-date-range-picker-actions>
                  <button mat-button matDateRangePickerCancel>Cancel</button>
                  <button mat-button="elevated" matDateRangePickerApply>Apply</button>
                </mat-date-range-picker-actions>
              </mat-date-range-picker>
            </mat-form-field>
          </div>
          <div class="date-range-actions" *ngIf="columnFilters['last_update']">
            <button mat-button class="clear-btn" (click)="clearDateRangeFilter('last_update', $event)">
              Clear
            </button>
          </div>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">{{ formatLocalDateTime(row.last_update) }}</td>
    </ng-container>

    <!-- Status -->
    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-with-filter">
          <span>Status</span>
          <button mat-icon-button class="filter-icon" 
                  [class.active]="activeFilterColumn === 'status'"
                  (click)="openColumnFilter('status', $event)">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>
        <!-- Filter popup -->
        <div class="filter-popup" *ngIf="activeFilterColumn === 'status'" 
             [style.top]="popupPosition.top" 
             [style.left]="popupPosition.left">
          <!-- Active filter tags -->
          <div class="filter-tags" *ngIf="getFilterValues('status').length > 0">
            <span class="filter-tag" *ngFor="let value of getFilterValues('status')">
              {{ value }}
              <button class="remove-tag" (click)="removeFilterValue('status', value, $event)">×</button>
            </span>
          </div>
          <!-- Dropdown for status filter -->
          <div class="filter-dropdown-group">
            <select matInput 
                    class="filter-dropdown"
                    (change)="onSelectChange('status', $event)"
                    (click)="onInputClick($event)">
              <option value="">Select Status...</option>
              <option *ngFor="let option of getUniqueValues('status')" [value]="option">
                {{ option }}
              </option>
            </select>
          </div>
          <button mat-button class="clear-btn" (click)="clearColumnFilter('status', $event)">Clear All</button>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">
        <ng-container *ngIf="row.callResultStatusId !== null && row.callResultStatusId !== undefined && row.status && row.status.trim().length > 0">
          <span class="status-pill" [ngClass]="row.status.toLowerCase()">{{ row.status }}</span>
        </ng-container>
      </td>
    </ng-container>

    <!-- Name -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-with-filter">
          <span>Name</span>
          <button mat-icon-button class="filter-icon" 
                  [class.active]="activeFilterColumn === 'name'"
                  (click)="openColumnFilter('name', $event)">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>
        <!-- Filter popup -->
        <div class="filter-popup" *ngIf="activeFilterColumn === 'name'" 
             [style.top]="popupPosition.top" 
             [style.left]="popupPosition.left">
          <!-- Active filter tags -->
          <div class="filter-tags" *ngIf="getFilterValues('name').length > 0">
            <span class="filter-tag" *ngFor="let value of getFilterValues('name')">
              {{ value }}
              <button class="remove-tag" (click)="removeFilterValue('name', value, $event)">×</button>
            </span>
          </div>
          <!-- Input for new filter -->
          <div class="filter-input-group">
            <input matInput 
                   placeholder="Filter name..." 
                   [value]="getTempFilterValue('name')"
                   (input)="onInputChange('name', $event)"
                   (keydown)="onKeyDown('name', $event)"
                   (keyup.enter)="addFilterValue('name', getTempFilterValue('name'))"
                   (keydown.escape)="setTempFilterValue('name', ''); activeFilterColumn = null"
                   (click)="onInputClick($event)"
                   (focus)="onInputFocus($event)">
            <button mat-button class="add-filter-btn" 
                    (click)="addFilterValue('name', getTempFilterValue('name'))"
                    [disabled]="!getTempFilterValue('name') || getTempFilterValue('name').trim() === ''">
              Add
            </button>
          </div>
          <button mat-button class="clear-btn" (click)="clearColumnFilter('name', $event)">Clear All</button>
        </div>
      </th>
      <td mat-cell *matCellDef="let row" class="name-link">
        <a [href]="comtrakURL + '/patientprofile/' + row.patient_id" target="_blank">
          {{ row.name }}
        </a>
      </td>
    </ng-container>

    <!-- Cadence Attempt Count -->
    <ng-container matColumnDef="cadenceAttemptCount">
      <th mat-header-cell *matHeaderCellDef>
        Cadence Attempt
      </th>
      <td mat-cell *matCellDef="let row">
        {{ row.cadenceAttemptCount ?? '-' }}
      </td>
    </ng-container>

    <!-- Pool ID -->
    <ng-container matColumnDef="poolId">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-with-filter">
          <span>Pool ID</span>
          <button mat-icon-button class="filter-icon" 
                  [class.active]="activeFilterColumn === 'poolId'"
                  (click)="openColumnFilter('poolId', $event)">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>
        <!-- Filter popup -->
        <div class="filter-popup" *ngIf="activeFilterColumn === 'poolId'" 
             [style.top]="popupPosition.top" 
             [style.left]="popupPosition.left">
          <!-- Active filter tags -->
          <div class="filter-tags" *ngIf="getFilterValues('poolId').length > 0">
            <span class="filter-tag" *ngFor="let value of getFilterValues('poolId')">
              {{ value }}
              <button class="remove-tag" (click)="removeFilterValue('poolId', value, $event)">×</button>
            </span>
          </div>
          <!-- Input for new filter -->
          <div class="filter-input-group">
            <input matInput 
                   placeholder="Filter Pool ID..." 
                   [value]="getTempFilterValue('poolId')"
                   (input)="onInputChange('poolId', $event)"
                   (keydown)="onKeyDown('poolId', $event)"
                   (keyup.enter)="addFilterValue('poolId', getTempFilterValue('poolId'))"
                   (keydown.escape)="setTempFilterValue('poolId', ''); activeFilterColumn = null"
                   (click)="onInputClick($event)"
                   (focus)="onInputFocus($event)">
            <button mat-button class="add-filter-btn" 
                    (click)="addFilterValue('poolId', getTempFilterValue('poolId'))"
                    [disabled]="!getTempFilterValue('poolId') || getTempFilterValue('poolId').trim() === ''">
              Add
            </button>
          </div>
          <button mat-button class="clear-btn" (click)="clearColumnFilter('poolId', $event)">Clear All</button>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.poolId ?? '-' }}</td>
    </ng-container>

    <!-- Phone -->
    <ng-container matColumnDef="phone">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-with-filter">
          <span>Phone</span>
          <button mat-icon-button class="filter-icon" 
                  [class.active]="activeFilterColumn === 'phone'"
                  (click)="openColumnFilter('phone', $event)">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>
        <!-- Filter popup -->
        <div class="filter-popup" *ngIf="activeFilterColumn === 'phone'" 
             [style.top]="popupPosition.top" 
             [style.left]="popupPosition.left">
          <!-- Active filter tags -->
          <div class="filter-tags" *ngIf="getFilterValues('phone').length > 0">
            <span class="filter-tag" *ngFor="let value of getFilterValues('phone')">
              {{ value }}
              <button class="remove-tag" (click)="removeFilterValue('phone', value, $event)">×</button>
            </span>
          </div>
          <!-- Input for new filter -->
          <div class="filter-input-group">
            <input matInput 
                   placeholder="Filter phone..." 
                   [value]="getTempFilterValue('phone')"
                   (input)="onInputChange('phone', $event)"
                   (keydown)="onKeyDown('phone', $event)"
                   (keyup.enter)="addFilterValue('phone', getTempFilterValue('phone'))"
                   (keydown.escape)="setTempFilterValue('phone', ''); activeFilterColumn = null"
                   (click)="onInputClick($event)"
                   (focus)="onInputFocus($event)">
            <button mat-button class="add-filter-btn" 
                    (click)="addFilterValue('phone', getTempFilterValue('phone'))"
                    [disabled]="!getTempFilterValue('phone') || getTempFilterValue('phone').trim() === ''">
              Add
            </button>
          </div>
          <button mat-button class="clear-btn" (click)="clearColumnFilter('phone', $event)">Clear All</button>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.phone }}</td>
    </ng-container>

    <!-- Email -->
    <ng-container matColumnDef="email">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-with-filter">
          <span>Email</span>
          <button mat-icon-button class="filter-icon" 
                  [class.active]="activeFilterColumn === 'email'"
                  (click)="openColumnFilter('email', $event)">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>
        <!-- Filter popup -->
        <div class="filter-popup" *ngIf="activeFilterColumn === 'email'" 
             [style.top]="popupPosition.top" 
             [style.left]="popupPosition.left">
          <!-- Active filter tags -->
          <div class="filter-tags" *ngIf="getFilterValues('email').length > 0">
            <span class="filter-tag" *ngFor="let value of getFilterValues('email')">
              {{ value }}
              <button class="remove-tag" (click)="removeFilterValue('email', value, $event)">×</button>
            </span>
          </div>
          <!-- Input for new filter -->
          <div class="filter-input-group">
            <input matInput 
                   placeholder="Filter email..." 
                   [value]="getTempFilterValue('email')"
                   (input)="onInputChange('email', $event)"
                   (keydown)="onKeyDown('email', $event)"
                   (keyup.enter)="addFilterValue('email', getTempFilterValue('email'))"
                   (keydown.escape)="setTempFilterValue('email', ''); activeFilterColumn = null"
                   (click)="onInputClick($event)"
                   (focus)="onInputFocus($event)">
            <button mat-button class="add-filter-btn" 
                    (click)="addFilterValue('email', getTempFilterValue('email'))"
                    [disabled]="!getTempFilterValue('email') || getTempFilterValue('email').trim() === ''">
              Add
            </button>
          </div>
          <button mat-button class="clear-btn" (click)="clearColumnFilter('email', $event)">Clear All</button>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">{{ (row.email?.trim() || '-') }}</td>
    </ng-container>

    <!-- Zip Code -->
    <ng-container matColumnDef="zipcode">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-with-filter">
          <span>Zip Code</span>
          <button mat-icon-button class="filter-icon" 
                  [class.active]="activeFilterColumn === 'zipcode'"
                  (click)="openColumnFilter('zipcode', $event)">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>
        <!-- Filter popup -->
        <div class="filter-popup" *ngIf="activeFilterColumn === 'zipcode'" 
             [style.top]="popupPosition.top" 
             [style.left]="popupPosition.left">
          <!-- Active filter tags -->
          <div class="filter-tags" *ngIf="getFilterValues('zipcode').length > 0">
            <span class="filter-tag" *ngFor="let value of getFilterValues('zipcode')">
              {{ value }}
              <button class="remove-tag" (click)="removeFilterValue('zipcode', value, $event)">×</button>
            </span>
          </div>
          <!-- Input for new filter -->
          <div class="filter-input-group">
            <input matInput 
                   placeholder="Filter zip code..." 
                   [value]="getTempFilterValue('zipcode')"
                   (input)="onInputChange('zipcode', $event)"
                   (keydown)="onKeyDown('zipcode', $event)"
                   (keyup.enter)="addFilterValue('zipcode', getTempFilterValue('zipcode'))"
                   (keydown.escape)="setTempFilterValue('zipcode', ''); activeFilterColumn = null"
                   (click)="onInputClick($event)"
                   (focus)="onInputFocus($event)">
            <button mat-button class="add-filter-btn" 
                    (click)="addFilterValue('zipcode', getTempFilterValue('zipcode'))"
                    [disabled]="!getTempFilterValue('zipcode') || getTempFilterValue('zipcode').trim() === ''">
              Add
            </button>
          </div>
          <button mat-button class="clear-btn" (click)="clearColumnFilter('zipcode', $event)">Clear All</button>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.zipcode }}</td>
    </ng-container>

    <!-- Metro Area -->
    <ng-container matColumnDef="metroArea">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-with-filter">
          <span>Metro Area</span>
          <button mat-icon-button class="filter-icon" 
                  [class.active]="activeFilterColumn === 'metroArea'"
                  (click)="openColumnFilter('metroArea', $event)">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>
        <!-- Filter popup -->
        <div class="filter-popup" *ngIf="activeFilterColumn === 'metroArea'" 
             [style.top]="popupPosition.top" 
             [style.left]="popupPosition.left">
          <!-- Active filter tags -->
          <div class="filter-tags" *ngIf="getFilterValues('metroArea').length > 0">
            <span class="filter-tag" *ngFor="let value of getFilterValues('metroArea')">
              {{ value }}
              <button class="remove-tag" (click)="removeFilterValue('metroArea', value, $event)">×</button>
            </span>
          </div>
          <!-- Dropdown for metro area filter -->
          <div class="filter-dropdown-group">
            <select matInput 
                    class="filter-dropdown"
                    (change)="onSelectChange('metroArea', $event)"
                    (click)="onInputClick($event)">
              <option value="">Select Metro Area...</option>
              <option *ngFor="let option of getUniqueValues('metroArea')" [value]="option">
                {{ option }}
              </option>
            </select>
          </div>
          <button mat-button class="clear-btn" (click)="clearColumnFilter('metroArea', $event)">Clear All</button>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.metroArea }}</td>
    </ng-container>

    <!-- Date of Birth -->
    <ng-container matColumnDef="dob">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Date of Birth</th>
      <td mat-cell *matCellDef="let row">{{ row.dob }}</td>
    </ng-container>

    <!-- Call Attempts -->
    <ng-container matColumnDef="interactions">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Call Attempts</th>
      <td mat-cell *matCellDef="let row">{{ row.interactions }}</td>
    </ng-container>
    

    <!-- Study -->
    <ng-container matColumnDef="study">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Study</th>
      <td mat-cell *matCellDef="let row">{{ row.study }}</td>
    </ng-container>

    <!-- Transfer -->
    <ng-container matColumnDef="transfer">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Transfer</th>
      <td mat-cell *matCellDef="let row">{{ row.transfer }}</td>
    </ng-container>

    <!-- Agent Name -->
    <ng-container matColumnDef="agentName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-with-filter">
          <span>Agent Name</span>
          <button mat-icon-button class="filter-icon" 
                  [class.active]="activeFilterColumn === 'agentName'"
                  (click)="openColumnFilter('agentName', $event)">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>
        <!-- Filter popup -->
        <div class="filter-popup" *ngIf="activeFilterColumn === 'agentName'" 
             [style.top]="popupPosition.top" 
             [style.left]="popupPosition.left">
          <!-- Active filter tags -->
          <div class="filter-tags" *ngIf="getFilterValues('agentName').length > 0">
            <span class="filter-tag" *ngFor="let value of getFilterValues('agentName')">
              {{ value }}
              <button class="remove-tag" (click)="removeFilterValue('agentName', value, $event)">×</button>
            </span>
          </div>
          <!-- Dropdown for agent name filter -->
          <div class="filter-dropdown-group">
            <select matInput 
                    class="filter-dropdown"
                    (change)="onSelectChange('agentName', $event)"
                    (click)="onInputClick($event)">
              <option value="">Select Agent Name...</option>
              <option *ngFor="let option of getUniqueValues('agentName')" [value]="option">
                {{ option }}
              </option>
            </select>
          </div>
          <button mat-button class="clear-btn" (click)="clearColumnFilter('agentName', $event)">Clear All</button>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.agentName }}</td>
    </ng-container>

    <!-- Agent Type -->
    <ng-container matColumnDef="agentType">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Agent Type</th>
      <td mat-cell *matCellDef="let row">{{ row.agentType }}</td>
    </ng-container>

    <!-- Gender -->
    <ng-container matColumnDef="gender">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        <div class="header-with-filter">
          <span>Gender</span>
          <button mat-icon-button class="filter-icon" 
                  [class.active]="activeFilterColumn === 'gender'"
                  (click)="openColumnFilter('gender', $event)">
            <mat-icon>filter_list</mat-icon>
          </button>
        </div>
        <!-- Filter popup -->
        <div class="filter-popup" *ngIf="activeFilterColumn === 'gender'" 
             [style.top]="popupPosition.top" 
             [style.left]="popupPosition.left">
          <!-- Active filter tags -->
          <div class="filter-tags" *ngIf="getFilterValues('gender').length > 0">
            <span class="filter-tag" *ngFor="let value of getFilterValues('gender')">
              {{ value }}
              <button class="remove-tag" (click)="removeFilterValue('gender', value, $event)">×</button>
            </span>
          </div>
          <!-- Dropdown for gender filter -->
          <div class="filter-dropdown-group">
            <select matInput 
                    class="filter-dropdown"
                    (change)="onSelectChange('gender', $event)"
                    (click)="onInputClick($event)">
              <option value="">Select Gender...</option>
              <option *ngFor="let option of getUniqueValues('gender')" [value]="option">
                {{ option }}
              </option>
            </select>
          </div>
          <button mat-button class="clear-btn" (click)="clearColumnFilter('gender', $event)">Clear All</button>
        </div>
      </th>
      <td mat-cell *matCellDef="let row">{{ row.gender }}</td>
    </ng-container>
    

    <!-- Header & Rows -->
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- No Data -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" colspan="16">No data found</td>
    </tr>

    <!-- Paginator Row (inside table for aligned width) -->

  </table>
  
  <!-- Paginator -->
  <mat-paginator [length]="totalCount"
                 [pageIndex]="pageIndex"
                 [pageSize]="pageSize"
                 [pageSizeOptions]="[10, 25, 50]"
                 (page)="onPageChange($event)"
                 aria-label="Select page"></mat-paginator>
</div>